import { moduleLinks } from "./moduleLinks";

export const baseAvatarUrl: string = `${process.env.REACT_APP_BASE_URL}/uploads/avatar/`;

export const defaultRoute: string = moduleLinks.find(moduleLink => moduleLink.default)?.path!;
